import { Field as FormikField, Form, Formik } from 'formik'
import { Button, Field } from '@/ui'
import cl from 'classnames'
import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import * as yup from 'yup'
import { string } from 'yup'

const FORM_NAME = {
	animalKind: 'animalKind',
	cnt: 'cnt',
}

const Validate = yup.object().shape({
	animalKind: string().required({ key: 'required' }).nullable(),
	cnt: string().required({ key: 'required' }).nullable(),
})

export const CalcAnimalForm = memo(({
																			handleSubmit,
																			initialState,
																			handleReset,
																			handleChange,
																			values,
																		}) => {
	const { t } = useTranslation()

	const { animalKind } = useSelector((state) => ({
		animalKind: state.handbook.animalKind,
	}))

	return (
		<Formik initialValues={initialState}
						onSubmit={handleSubmit} validationSchema={Validate}>
			{({ setValues }) => {
				return (
					<Form className={cl('flex', 'gap-3', 'align-items-start')}>
						<FormikField name={FORM_NAME.animalKind}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									fieldType={'select'}
									label={t('requirement_labor_resources.form.animal_category')}
									placeholder={t('requirement_labor_resources.form.choose_category')}
									options={animalKind}
									value={values[FORM_NAME.animalKind]}
									error={touched && error}
									onChange={(value) => {
										field.onChange(value)
										handleChange({ ...values, [FORM_NAME.animalKind]: value })
									}}
								/>
							)}
						</FormikField>

						<FormikField name={FORM_NAME.cnt}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									fieldType={'input'}
									type="number"
									min={0}
									hideNumberArrows
									label={t('requirement_labor_resources.form.head')}
									placeholder={t('requirement_labor_resources.form.count')}
									value={values[FORM_NAME.cnt]}
									error={touched && error}
									onChange={(value) => {
										field.onChange(value)
										handleChange({ ...values, [FORM_NAME.cnt]: value })
									}}
								/>
							)}
						</FormikField>

						<div className={cl('flex', 'align-items-end')} style={{ height: 70 }}>
							<div className={cl('flex', 'gap-3', 'align-items-center')}>
								<Button type="submit">
									{t('requirement_labor_resources.calculate')}
								</Button>

								<Button type="bare" onClick={() => {
									handleReset()
									setValues(initialState)
								}}>
									{t('reset_all')}
								</Button>
							</div>
						</div>
					</Form>
				)
			}}
		</Formik>
	)
})